import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SidebarIconReports from './sidebar-icon-reports.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SidebarIconReports {...validProps} />;
}
SvgComponent.iconName = 'sidebarIconReports';

/**
 * @deprecated This is a legacy icon
 */
export const SidebarIconReportsIcon = svgIconWrapper(SvgComponent);
